import { h } from "preact";
import { useState, useRef, useCallback } from "preact/hooks";
import { CSSTransition } from "react-transition-group";
import MonogramTrigger from "../monogram-trigger/monogram-trigger";
import { monogramHandleFor } from "../monogram/monogramTypeConfig";

export default function ProductOptionVariantContent({
  open,
  variant,
  monogram,
  setMonogram,
  smallMonogram = false,
}) {
  const [height, setHeight] = useState(0);
  const nodeRef = useRef();
  const roRef = useRef(null);

  // Callback ref on the inner element: it mounts/unmounts with the CSSTransition,
  // so attaching the ResizeObserver here (rather than in a mount effect) keeps
  // --height in sync whether the panel mounted already open or appears later on
  // a toggle.
  const observeInner = useCallback((node) => {
    roRef.current?.disconnect();
    roRef.current = null;
    if (!node) return;
    roRef.current = new ResizeObserver(() => {
      if (nodeRef.current) setHeight(nodeRef.current.scrollHeight);
    });
    roRef.current.observe(node);
  }, []);

  const monogramHandle = monogramHandleFor(variant);

  return (
    <CSSTransition
      mountOnEnter={true}
      unmountOnExit={true}
      in={open}
      nodeRef={nodeRef}
      classNames="product-option-variant__content-"
      onExited={() => setMonogram(null)}
      addEndListener={(done) => {
        nodeRef.current?.addEventListener("transitionend", done, false);
      }}
    >
      <div
        className="product-option-variant__content"
        ref={nodeRef}
        style={{ "--height": `${height}px` }}
      >
        <div
          className="product-option-variant__content-inner"
          ref={observeInner}
        >
          <MonogramTrigger
            handle={monogramHandle}
            value={monogram}
            currentVariant={variant}
            onChange={setMonogram}
            small={smallMonogram}
          />
        </div>
      </div>
    </CSSTransition>
  );
}
